import validate from 'validate.js';

export const validateLinkedinURL = (url) => {};

export const validateURL = (url) => {};

export const validateEmail = (email) => {
  return validate({ email: email }, { email: { email: true } }) === undefined;
};

export const getHighestQualityVideoURL = (files) => {};

export const getPortraitThumbnail = (thumbnails) => {};

export const getHighestQualityThumbnail = (thumbnails) => {};

export const getFormattedDate = (epochTime) => {};

export const tooltipDelay = 500;

export const checkTimeDiff = (videoUploadedTime) => {};

export const capitalizeText = (text) => {
  return text
    ?.trim()
    ?.split(' ')
    ?.filter((w) => w.trim())
    ?.map((w) => `${w.split('')[0].toUpperCase()}${w.slice(1)}`)
    .join(' ');
};

export const artifactTypesWithoutMedia = [
  'email-inbound',
  'email-outbound',
  'email-internal',
  'email-outbound-internal',
  'email-inbound-internal',
  'note',
];

export const showBuyerInputForArtifactTypes = [
  'email-inbound',
  'email-outbound',
  'call',
  'call-internal',
  'meeting',
  'meeting-internal',
];

export const showSellerInputForArtifactTypes = [
  'email-inbound',
  'email-outbound',
  'email-internal',
  'email-outbound-internal',
  'email-inbound-internal',
  'call',
  'call-internal',
  'meeting',
  'meeting-internal',
];

export const artifactStatusMap = {
  pending: 'Analyze Activity.',
  transcription_in_process: 'Transcription in progress.',
  transcription_failed: 'Transcription failed. Retry!',
  transcription_completed: 'Transcription completed. Analyze Activity.',
  file_analysis_in_process: 'Analysis in progress.',
  file_analysis_failed: 'Analysis failed. Retry!',
  file_analysis_completed: 'Analysis in progress.',
  in_process: 'Analysis in progress.',
  interaction_analysis_in_process: 'Analysis in progress.',
  interaction_risk_recommendation_failed: 'Analysis failed. Retry!',
  interaction_analysis_failed: 'Analysis failed. Retry!',
  interaction_analysis_completed:
    'Analysis Completed. Generate Next Best Actions.',
  completed: 'Completed.',
  interaction_nba_failed:
    'Failed to generate Next Best Actions. Please Try Again!',
  interaction_nba_completed: 'Completed.',
};

export const artifactProcessingStatuses = [
  'transcription_in_process',
  'file_analysis_in_process',
  'interaction_analysis_in_process',
  'in_process',
];

export const artifactFailedStatuses = [
  'transcription_failed',
  'file_analysis_failed',
  'interaction_nba_failed',
  'interaction_analysis_failed',
];

export const artifactStatusToStepMap = {
  pending: 1,
  in_process: 1,
  transcription_in_process: 1,
  transcription_failed: 1,
  transcription_completed: 1,
  file_analysis_in_process: 2,
  file_analysis_failed: 1,
  file_analysis_completed: 2,
  interaction_analysis_in_process: 2,
  interaction_risk_recommendation_failed: 1,
  interaction_analysis_failed: 1,
  interaction_analysis_completed: 3,
  completed: 3,
  interaction_nba_failed: 3,
  interaction_nba_completed: 4,
};

export const addArtifactTitleToStatusMap = {
  pending: 'Analyze Activity.',
  transcription_in_process: 'Transcription in progress.',
  transcription_failed: 'Transcription failed. Retry!',
  transcription_completed: 'Analyze Activity.',
  file_analysis_in_process: 'Analysis in progress.',
  file_analysis_failed: 'Analysis failed. Retry!',
  file_analysis_completed: 'Analysis in progress.',
  in_process: 'Analysis in progress.',
  interaction_analysis_in_process: 'Analysis in progress.',
  interaction_risk_recommendation_failed: 'Analysis failed. Retry!',
  interaction_analysis_failed: 'Analysis failed. Retry!',
  interaction_analysis_completed: 'Generate Next Best Actions.',
  completed: 'Completed.',
  interaction_nba_failed: '',
  interaction_nba_completed: 'Completed.',
};
